var map = {
	"./Glossary of Non Human Love 1.jpg": 5100,
	"./Glossary of Non Human Love 2.jpg": 2075,
	"./Glossary of Non Human Love 3.jpg": 766,
	"./Glossary of Non Human Love 4.jpg": 8101,
	"./Glossary of Non Human Love 5.jpg": 4136,
	"./Glossary of Non Human Love 6.jpg": 1415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 536;